import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import MicroModal from './tailwind/MicroModal';
// Tailwind UI Elements
import {Collapse, Offcanvas, Ripple, initTE,} from "tw-elements";
import TableResponsive from './services/table_responsive/TableResponsive';
import CollapsibleButton from '@RESOURCES/js/services/collapsible/CollapsibleButton';
import Collapsible from '@RESOURCES/js/services/collapsible/Collapsible';

import AnchorMenuScroll from "./tailwind/anchor-menu-scroll";
import VisitorCountryRedirect from './tailwind/visitor-country-redirect';

Alpine.plugin(collapse);
window.Alpine = Alpine;

Alpine.start();

// app specific js utilities
function init() {
    new AnchorMenuScroll();
    new VisitorCountryRedirect();
}

init();

window.MicroModal = MicroModal;

initTE({Collapse, Offcanvas, Ripple});

new TableResponsive().init();

global.CollapsibleButton = CollapsibleButton;
global.Collapsible = Collapsible;
